import { Component } from '@angular/core';

@Component({
  selector: 'app-average-cost-movement',
  standalone: false,
  
  templateUrl: './average-cost-movement.component.html',
  styles: ``
})
export class AverageCostMovementComponent {

}
